/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./spud.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./spud.component";
var styles_SpudComponent = [i0.styles];
var RenderType_SpudComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SpudComponent, data: {} });
export { RenderType_SpudComponent as RenderType_SpudComponent };
export function View_SpudComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.spud.name; _ck(_v, 1, 0, currVal_0); }); }
export function View_SpudComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-spud", [], null, null, null, View_SpudComponent_0, RenderType_SpudComponent)), i1.ɵdid(1, 114688, null, 0, i2.SpudComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SpudComponentNgFactory = i1.ɵccf("app-spud", i2.SpudComponent, View_SpudComponent_Host_0, { spud: "spud" }, {}, []);
export { SpudComponentNgFactory as SpudComponentNgFactory };
